/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S1_Label_TelefonInputs */

const tr_onbilgi_s1_label_telefon = /** @type {(inputs: Onbilgi_S1_Label_TelefonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon:`)
};

const en_onbilgi_s1_label_telefon = /** @type {(inputs: Onbilgi_S1_Label_TelefonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone:`)
};

const de_onbilgi_s1_label_telefon = /** @type {(inputs: Onbilgi_S1_Label_TelefonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon:`)
};

const ru_onbilgi_s1_label_telefon = /** @type {(inputs: Onbilgi_S1_Label_TelefonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Телефон:`)
};

/**
* | output |
* | --- |
* | "Phone:" |
*
* @param {Onbilgi_S1_Label_TelefonInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s1_label_telefon = /** @type {((inputs?: Onbilgi_S1_Label_TelefonInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S1_Label_TelefonInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s1_label_telefon(inputs)
	if (locale === "de") return de_onbilgi_s1_label_telefon(inputs)
	if (locale === "ru") return ru_onbilgi_s1_label_telefon(inputs)
	return tr_onbilgi_s1_label_telefon(inputs)
});